function sizeOptionListener () {
  const unseletedSizeFieldsets = document.querySelectorAll('[data-option="size"][data-variant-selected="false"]')
  unseletedSizeFieldsets.forEach((fieldset) => {
    const firstLabel = fieldset.querySelector('label')
    const input = fieldset.querySelector(`input#${firstLabel.getAttribute('for')}`)
    
    firstLabel.addEventListener('click', () => {
      input.checked = false
      input.dispatchEvent(new Event('change'), { bubbles: true })
      fieldset.setAttribute('data-variant-selected', 'true')
    }, { once: true })
  })
}

document.addEventListener('DOMContentLoaded', function() {
  sizeOptionListener()
})